import React from 'react';
import { signIn } from '../firebase';
import Button from '@material-ui/core/Button';
import Google_logo from '../styles/google_logo.png';


const Homepage = () => {
    return (
        <div className="home-page">
            <h1>Welcome to Recipe App</h1>
            <Button
            className="login-button"
            onClick={signIn}
            startIcon={<img src={Google_logo} alt="logo"/>}>
            Log In with Google
            </Button>
        </div>
    )
}

export default Homepage;
